import { ApiConcept } from "types/swagger/clarifai-api";
import toastMessage from 'components/ToastMessage/ToastMessage';
import { getApiConcepts } from "api-proxy/private/createAIAssistRegionAnnotation/getApiConcepts";
import { getOrCreateConceptRelation } from "api-proxy/private/getOrCreateConceptRelation";
import { getOrCreateValidAppConcept } from "api-proxy/private/createAIAssistRegionAnnotation/getOrCreateValidAppConcept";
import { getOrCreateValidAiConcept } from "api-proxy/private/createAIAssistRegionAnnotation/getOrCreateValidAiConcept";

type GetAIAssistRegionAnnotationConceptProps = {
    request: {
        userOrOrgId: string;
        appId: string;
    };
    aiConcept: {
        id: string;
        name: string;
        appId: string;
        userId: string;
    };
}

const _pushErrorMessage = (message: string) => {
    console.error(message);
    toastMessage.error(message);
};

// TODO: Check if this will work for org apps, and for apps where someone else is a collaborator
// There might be mismatch in request.userOrOrgId / aiConcept.userId / currentlyLoggedInUserId (not present here)
export const getAIAssistRegionAnnotationConcept = async ({ request, aiConcept }: GetAIAssistRegionAnnotationConceptProps): Promise<ApiConcept | undefined> => {
    // Step 1: Fetch available concepts from API
    const {
        apiAiConcept,
        apiAppConcept,
    } = await getApiConcepts({ request, aiConcept });
    
    // Step 2: Get valid AI concept
    const validAiConcept = await getOrCreateValidAiConcept({ apiAiConcept, request, aiConcept });
    if (!validAiConcept) {
        _pushErrorMessage("Cannot get validAiConcept. Aborting createAIAssistRegionAnnotation.");
        return;
    }
    
    // Step 3: Get valid AI concept
    const validAppConcept = await getOrCreateValidAppConcept({ apiAppConcept, validAiConcept, request });
    if (!validAppConcept) {
        _pushErrorMessage("Cannot get validAppConcept. Aborting createAIAssistRegionAnnotation.");
        return;
    }

    // Step 4: Get valid concept relation
    const validConceptRelation = await getOrCreateConceptRelation({ request, appConcept: validAppConcept, aiConcept: validAiConcept });
    if (!validConceptRelation) {
        _pushErrorMessage("Cannot get validConceptRelation. Aborting createAIAssistRegionAnnotation.");
        return;
    }

    // Step 5: Success. All concepts and concept relations have been validated/created.
    return validAppConcept;
};
